import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { freddyTheme } from '@coolblue-development/freddy';
import { AccountOutlined, CheckmarkCircled, CrossCircled } from '@coolblue-development/icons';
import { StyledIconContainer, StyledSubIcon } from './AccountMenuIcon.styled.js';
const AccountMenuIcon = ({ isCustomerRecognised }) => {
    return (_jsxs(StyledIconContainer, { children: [_jsx(AccountOutlined, { size: 24 }), _jsx(StyledSubIcon, { children: isCustomerRecognised ? (_jsx(CheckmarkCircled, { fill: freddyTheme.color.icon.sentimentPositive, innerFill: "contrast" })) : (_jsx(CrossCircled, { fill: freddyTheme.color.icon.accented, innerFill: "contrast" })) })] }));
};
export default AccountMenuIcon;
//# sourceMappingURL=AccountMenuIcon.js.map